import React from "react";
import {
  Box,
  Typography,
  Paper,
  styled,
  Grid,
  InputLabel,
  Divider,
} from "@mui/material";
import { CampaignFormSteps, Products } from "../../../enum/campaign";
import { IWithClassName } from "../../../theme/default.theme";
import { ICampaignSettings } from "../../../interfaces/campaign";
import MediaTiles from "./media-tiles";

interface IProps extends IWithClassName {
  activeStep: CampaignFormSteps;
  form: ICampaignSettings;
}

const Summary = ({ activeStep, form, className }: IProps) => {
  return (
    <>
      {activeStep === CampaignFormSteps.Summary && (
        <Box className={className}>
          <Box className="summary-container">
            <Box className="summary-section" component={Paper}>
              <Typography variant="h6">Settings</Typography>
              <Divider />
              <Grid className="summary-grid">
                <Grid item xs={12} md={4}>
                  <InputLabel>Name:</InputLabel> {form.name}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Product:</InputLabel> {form.product}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Campaign Type:</InputLabel> {form.type}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Web URL:</InputLabel>
                  {form.product === Products.Website
                    ? form.webUrl
                    : form.app?.title}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>End Date:</InputLabel> {form.endDate}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Start Date:</InputLabel> {form.startDate}
                </Grid>
              </Grid>
            </Box>

            <Box className="summary-section" component={Paper}>
              <Typography variant="h6">Target</Typography>
              <Divider />
              <Grid className="summary-grid">
                <Grid item xs={12} md={4}>
                  <InputLabel>Age Group:</InputLabel>{" "}
                  {form.ageGroups?.map(({ name }) => name).join(", ")}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Interest:</InputLabel>{" "}
                  {form.interests?.map(({ name }) => name).join(", ")}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Language:</InputLabel>{" "}
                  {form.languages?.map(({ name }) => name).join(", ")}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Country:</InputLabel> {form.country}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>State:</InputLabel>{" "}
                  {form.states?.map(({ name }) => name).join(", ")}
                </Grid>
              </Grid>
            </Box>

            <Box className="summary-section" component={Paper}>
              <Typography variant="h6">Budget</Typography>
              <Divider />
              <Grid className="summary-grid">
                <Grid item xs={12} md={4}>
                  <InputLabel>Bid Type:</InputLabel> {form.bidType}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Bid Amount:</InputLabel> ${form.bidAmount}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Total Budget:</InputLabel> ${form.totalBudget}
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel>Daily Budget:</InputLabel> ${form.dailyBudget}
                </Grid>
              </Grid>
            </Box>

            <Box className="summary-section" component={Paper}>
              <Typography variant="h6">Media</Typography>
              <Divider />
              <Grid className="summary-grid">
                <Grid item xs={12} md={4}>
                  <MediaTiles
                    serverFiles={form.serverBanners}
                    files={form.bannerImage}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default styled(Summary)(({ theme }) => ({
  ".summary-container": {
    display: "grid",
    gap: 30,
    h6: {
      padding: theme.spacing(1, 2),
      fontWeight: 500,
    },
    ".summary-grid": {
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(2, 7),
      padding: theme.spacing(4),
    },
  },
}));
